import BigNumber from 'bignumber.js'
import { getTokenPriceFromGraph } from 'utils/getTokenPriceFromGraph'
import { useCallback } from 'react'
import { BIG_ZERO } from '../utils/bigNumber'
import { IFetchableConfig, useFetchable } from './useFetchable'

export function useYokaiPrice(address?: string | null, config?: IFetchableConfig) {
  const fetchPrice = useCallback(async () => {
    if (address == null) {
      throw new Error('trying to fetch yokai price without address')
    }

    const rawPrice = await getTokenPriceFromGraph(address)

    return new BigNumber(rawPrice)
  }, [address])

  return useFetchable(BIG_ZERO, fetchPrice, {
    ...config,
    refreshInterval: config?.refreshInterval ?? 30_000,
    shouldRetry: config?.shouldRetry ?? true,
    isDisabled: config?.isDisabled || address == null,
  })
}
